import React from 'react';
import { Switch, FormControlLabel } from '@mui/material';
import { tt } from '@i18n/tt';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setUIMode, UIModeSelector } from 'store/uiMode';
import useStyles from './styles';

const UISwitch: React.FC = () => {
  const dispatch = useAppDispatch();
  const isNewUI = useAppSelector(UIModeSelector);
  const classes = useStyles();

  return (
    <FormControlLabel
      control={
        <Switch
          className={classes.uiSwitch}
          checked={isNewUI}
          onChange={(_, checked) => {
            dispatch(setUIMode(checked));
          }}
        />
      }
      label={isNewUI ? tt('ui.new') : tt('ui.old') }
    />
  );
};

export default UISwitch;
